export function copy(source) {
    return JSON.parse(JSON.stringify(source));
}

export function getAmount(amount) {
    return Number(amount.replace(/[^\d]/g, "")) / 100;
}

export function formatAmount(amount) {
    if (amount) {
        return amount.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    }
    return "R$ 0,00";
}

export function getDate(date) {
    return `${date.slice(6, 10)}-${date.slice(3, 5)}-${date.slice(0, 2)}`;
}

export const formatDateTime = value => {
    if (value) {
        const date = new Date(value);
        const localeDate = date.toLocaleDateString('pt-BR');
        const localeTime = date.toLocaleTimeString('pt-BR');
        const localeDateTime = `${(localeDate) ? localeDate : ''} ${(localeTime) ? ` - ${localeTime}` : ''}`;
        return localeDateTime;
    }
    return '';
}

export function formatDate(date) {
  if (date) {
    let dateObject = new Date(date);
    return dateObject.toLocaleDateString('pt-BR');
  }

  return "";
}

// Usado para gerar filtros em GraphQL
export function buildFilter(data) {
  var filter = "(";
  for (let i=0; i < data.length; i++) {
    if (typeof data[i].value === 'string' || data[i].value instanceof String) {
      filter += data[i].filter + ':"' + data[i].value + '", '
    } else {
      filter += data[i].filter + ':' + data[i].value + ', '
    }
  }
  filter += ')';
  return filter.replace(', )', ')');
}


// WEBPACK FOOTER //
// ./src/Common/utils.js